import React, { Component, location, history } from 'react';
import {CardElement, injectStripe} from 'react-stripe-elements';
import {Elements, StripeProvider} from 'react-stripe-elements';
import { Dimmer, Loader, Segment, Button } from 'semantic-ui-react';
import  { Redirect } from 'react-router-dom';
import { withCookies, Cookies } from 'react-cookie';





import SideBar from '../SideBar/SideBar';
import HeaderBackend from '../photos/HeaderBackend/HeaderBackend';
import axios from 'axios/index';


import ViewerSettingsToggleSetting from './../viewer_sidebar/general_settings/ViewerSettingsToggleSetting';


const Settings = class Settings extends Component {



  constructor(props){
    super(props);
    const { cookies } = this.props;
    console.log('COOKIE: ', typeof  cookies.get("darkMode"));

    this.state = { isLoading: false};

  }

  handlePayment(type){
    console.log('org: ', this.props.org);
    this.setState({isLoading: true});
    axios.post('/api/checkout/' + this.props.org.id + "/" + type)
      .then((response) => {
        console.log('snapshot sent', response);
        this.props.stripe.redirectToCheckout({
          // Make the id field from the Checkout Session creation API response
          // available to this file, so you can provide it as parameter here
          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
          sessionId: response.data
        }).then(function (result) {
          console.log('result');
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
        });
      })
      .catch(function (error) {
        console.log(error);
      });

  }



  render() {

    if (!this.props.firebaseUser){
      return (<Redirect to='/login'  />)
    }

    return (

      <div className="backend-container" >
        <SideBar active={"settings"} />
        <div className="backend-body-container" style={{position: "relative"}}>
          {this.state.isLoading ? (
            <div style={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%"}}>
              <Segment style={{width: "100%", height: "100%"}}>
                <Dimmer active>
                  <Loader />
                </Dimmer>
              </Segment>
            </div>
          ) : (<div></div>)}
          <HeaderBackend title={"Account"} user={this.props.firebaseUser} firebase={this.props.firebase} handleUserUpdate={this.props.handleUserUpdate} org={this.props.org}/>

          <div className="div-block-24" style={{display: 'none'}}>
            <ViewerSettingsToggleSetting title={"Dark Mode"} isActive={this.props.darkMode} onPress={this.props.changeDarkMode} />
          </div>

          <div className="div-block-24">
            <h3 className="heading-2-copy">Current Balance</h3>
            <div className="addteammembercontainer"></div>
          </div>
          <div className="current-credits-container">
            <div className="div-block-31-copy">
              <div className="text-block-35-copy">{this.props.org ? this.props.org.credits : ""}</div>
              <div className="hover-icon-copy w-embed">
                <span dangerouslySetInnerHTML={{__html: "<svg height=\"40px\" width=\"40px\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 80 80\" enable-background=\"new 0 0 80 80\" xml:space=\"preserve\"><path d=\"M40,9.988c-20.402,0-37,11.215-37,25v12.847c0,4.535,2.01,8.774,5.515,11.63c5.451,4.443,12.117,7.572,19.415,9.215  c0,0,0.001,0,0.001,0c3.874,0.872,7.923,1.333,12.07,1.333s8.196-0.461,12.07-1.333c0,0,0.001,0,0.001,0  c7.298-1.643,13.964-4.772,19.415-9.215C74.99,56.608,77,52.37,77,47.834V34.988C77,21.203,60.402,9.988,40,9.988z M14.667,58.972  c-1.262-0.807-2.477-1.672-3.625-2.608C8.474,54.271,7,51.162,7,47.834v-1.562c1.953,2.597,4.556,4.933,7.667,6.912V58.972z   M26.333,64.159c-2.68-0.755-5.246-1.736-7.666-2.928v-5.835c2.366,1.133,4.936,2.082,7.666,2.818V64.159z M38,65.973  c-2.615-0.099-5.178-0.396-7.667-0.873v-5.984c2.465,0.451,5.028,0.738,7.667,0.834V65.973z M49.667,65.1  c-2.489,0.477-5.052,0.775-7.667,0.873V59.95c2.639-0.095,5.202-0.382,7.667-0.834V65.1z M73,47.834  c0,3.327-1.474,6.436-4.042,8.529c-1.148,0.936-2.363,1.8-3.625,2.608v-0.984c0-1.104-0.896-2-2-2s-2,0.896-2,2v3.243  c-2.42,1.193-4.986,2.173-7.666,2.928v-5.946c8.388-2.262,15.269-6.537,19.333-11.94V47.834z M51.328,54.713  c-0.048,0.008-0.095,0.019-0.142,0.031c-3.495,0.804-7.261,1.244-11.186,1.244s-7.691-0.44-11.186-1.244  c-0.047-0.012-0.094-0.022-0.142-0.031C16.039,51.766,7,44.036,7,34.988c0-11.58,14.804-21,33-21s33,9.42,33,21  C73,44.036,63.961,51.766,51.328,54.713z\"></path><path d=\"M58.892,31.164c-0.32-1.125-1.311-1.997-2.649-2.33l-7.635-1.904l-5.929-4.422c-1.479-1.102-3.879-1.102-5.357,0  l-5.929,4.422l-7.636,1.904c-1.338,0.333-2.328,1.205-2.648,2.33c-0.282,0.991-0.001,2.044,0.752,2.819l4.988,5.13l0.044,3.976  c0.011,0.887,0.425,1.703,1.168,2.299c0.977,0.784,2.433,1.094,3.801,0.808l7.941-1.663c0.121-0.027,0.269-0.027,0.396,0  l7.941,1.663c0.336,0.07,0.678,0.105,1.017,0.105c1.038,0,2.047-0.322,2.783-0.913c0.743-0.596,1.157-1.413,1.168-2.3l0.044-3.975  l4.988-5.13C58.893,33.208,59.174,32.154,58.892,31.164z M49.942,36.674c-0.498,0.513-0.777,1.171-0.785,1.856l-0.041,3.77  c-0.051-0.002-0.104-0.008-0.157-0.02l-7.939-1.663c-0.334-0.07-0.677-0.105-1.02-0.105s-0.686,0.035-1.019,0.105l-7.939,1.663  c-0.055,0.011-0.107,0.018-0.158,0.02l-0.041-3.771c-0.008-0.684-0.287-1.343-0.785-1.855l-4.14-4.257l6.494-1.619  c0.482-0.121,0.915-0.322,1.288-0.599l5.992-4.472c0.134-0.072,0.483-0.072,0.594-0.014l6.017,4.488  c0.37,0.275,0.803,0.477,1.287,0.597l6.487,1.624L49.942,36.674z\"></path><path d=\"M51.653,17.409c-1.071-0.272-2.159,0.378-2.429,1.449c-0.271,1.071,0.377,2.158,1.448,2.429  C60.438,23.757,67,29.263,67,34.988c0,1.776-0.624,3.543-1.855,5.252c-1.244,1.726-3.042,3.314-5.342,4.722  c-0.942,0.576-1.238,1.808-0.662,2.75c0.377,0.617,1.034,0.957,1.708,0.957c0.355,0,0.716-0.095,1.042-0.294  c2.756-1.686,4.942-3.635,6.498-5.795C70.121,40.175,71,37.621,71,34.988C71,27.281,63.406,20.381,51.653,17.409z\"></path></svg>"}} />
              </div>
            </div>
            <div className="credits-information-text-copy">Credits on Demand</div>
          </div>

          <div className="div-block-24">
            <h3 className="heading-2-copy">Add Credits</h3>
            <div className="addteammembercontainer"></div>
          </div>

          {this.props.pricingCMS ? (
            <div className="cta3-options-wrapper">
              <div className="_5-col">
                <div className="cta3-item-wrap">
                  <h2 className="h2-jumbo">{this.props.pricingCMS.tiers.small.name}</h2>
                  <p className="text-20">{this.props.pricingCMS.tiers.small.subheading}</p>
                  <p className="text-16 text-16-60">{this.props.pricingCMS.tiers.small.description}</p>
                  <div className="cta3-wide-button-wrap"><div onClick={() => { this.handlePayment("small"); window.analytics.track('Add Credits', {type: "intent-react",  bundle: "small", info: this.props.pricingCMS.tiers.small.buttonText, creditBalance: this.props.org ? this.props.org.credits : "undefined"  }); }}
                                                              className="btn btn-outline-light w-button">{this.props.pricingCMS.tiers.small.buttonText}</div></div>
                </div>
              </div>
              <div className="_5-col">
                <div className="cta3-item-wrap cta3-recommended-option">
                  <div className="label">
                    <div className="label-text">Recommended</div>
                  </div>
                  <h2 className="h2-jumbo">{this.props.pricingCMS.tiers.medium.name}</h2>
                  <p className="text-20">{this.props.pricingCMS.tiers.medium.subheading}<strong className="bold-text-2">{this.props.pricingCMS.tiers.medium.subheadingBold}</strong></p>
                  <p className="text-16 text-16-60">{this.props.pricingCMS.tiers.medium.description}</p>
                  <div className="cta3-wide-button-wrap"><div onClick={() => { this.handlePayment("medium"); window.analytics.track('Add Credits', {type: "intent-react",  bundle: "medium", info: this.props.pricingCMS.tiers.medium.buttonText, creditBalance: this.props.org ? this.props.org.credits : "undefined"   }); }}
                                                              className="btn-big w-button">{this.props.pricingCMS.tiers.medium.buttonText}</div></div>
                </div>
              </div>
              <div className="_5-col">
                <div className="cta3-item-wrap">
                  <h2 className="h2-jumbo">{this.props.pricingCMS.tiers.large.name}</h2>
                  <p className="text-20">{this.props.pricingCMS.tiers.large.subheading}<strong className="bold-text-2">{this.props.pricingCMS.tiers.large.subheadingBold}</strong></p>
                  <p className="text-16 text-16-60">{this.props.pricingCMS.tiers.large.description}</p>
                  <div className="cta3-wide-button-wrap"><div onClick={() => { this.handlePayment("large"); window.analytics.track('Add Credits', {type: "intent-react",  bundle: "large", info: this.props.pricingCMS.tiers.large.buttonText, creditBalance: this.props.org ? this.props.org.credits : "undefined" });}}
                                                              className="btn btn-outline-light w-button">{this.props.pricingCMS.tiers.large.buttonText}</div></div>
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )
          }

        </div>
      </div>

    );
  }
};


export default withCookies(injectStripe(Settings));
